import VueMoment from 'vue-moment';
import Vuex from 'vuex';
import VueRouter from 'vue-router';
import Vuebar from 'vuebar';
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en';
import Router from './router';
import Store from './store';
import FundationLayout from './App';
import DashboardLayout from './DashboardApp';
import DashboardLayoutV2 from './DashboardAppV2';
import SidebarLink from './components/layouts/dashboard/sidebarLink.vue';
import SimpleLayout from './components/partials/simple-layout.vue';
import NsPaginate from './components/partials/nsPaginate/index.vue';
import NsPaginate2 from './components/partials/nsPaginate2';
import ModalForm from './components/partials/modal-form.js';
import SecurityRules from './components/auth/rules-alert.vue';
import HttpErrorManager from './components/partials/http-error-manager.js';
import Tooltip from 'vue-directive-tooltip';
import 'vue-directive-tooltip/src/css/index.scss';
// Install the components
export function install(Vue/*, options = {}*/) { // Snd parameter : options
    Vue.use(ElementUI, {
        locale
    });
    Vue.use(VueMoment);
    Vue.use(VueRouter);
    Vue.use(Vuex);
    Vue.use(Vuebar);
    Vue.use(Tooltip, {
        delay: 0
    });

    Vue.component('DashboardLayout', DashboardLayout);
    Vue.component('DashboardLayoutV2', DashboardLayoutV2);
    Vue.component('FundationLayout', FundationLayout);
    Vue.component('SidebarLink', SidebarLink);
    Vue.component('SimpleLayout', SimpleLayout);
    Vue.component('NsPaginate', NsPaginate);
    Vue.component('ModalForm', ModalForm);


    // if(options.layout === 'dashboard'){
    //     console.debug();
    // }
    // We call Vue.mixin() here to inject functionality into all components.
    Vue.mixin({
        // Anything added to a mixin will be injected into all components.
        // In this case, the mounted() method runs when the component is added to the DOM.
        mounted() {
            // console.error('Fundation Mounted!');
        }
    });
}

// Expose the components
export {
    Router,
    Store,
    DashboardLayout,
    DashboardLayoutV2,
    FundationLayout,
    SidebarLink,
    SimpleLayout,
    NsPaginate,
    NsPaginate2,
    ModalForm,
    SecurityRules,
    HttpErrorManager,
};

/* -- Plugin definition & Auto-install -- */
/* You shouldn't have to modify the code below */

// Plugin
const plugin = {
    /* eslint-disable no-undef */
    version: VERSION,
    install,
};

export default plugin;

// Auto-install
let GlobalVue = null;
if (typeof window !== 'undefined') {
    GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
    GlobalVue = global.Vue;
}
if (GlobalVue) {
    GlobalVue.use(plugin);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/fundation-app-vuejs/src/index.js
// module id = TbXF
// module chunks = 0